<template>
    <div>
        <v-dialog v-model="dialog_deactivate_business" no-click-animation scrollable :overlay="false" fullscreen persistent transition="dialog-bottom-transition">
            <v-card>

                <v-toolbar fixed flat>
                    <v-toolbar-side-icon @click="$parent.fn_closeDialog">
                        <img src="../../../assets/back-icon.svg" style="margin-top:5px; width:28px"/>
                    </v-toolbar-side-icon>
                    <v-toolbar-title class="ml-5">Active Businesses</v-toolbar-title>
                </v-toolbar>

                <div class="hastoolbar">
                    <v-progress-linear indeterminate color="primary" v-if="!businesses"></v-progress-linear>
                    <v-card-text full-height nopadding v-if="businesses && businesses.length">
                        <v-list two-line subheader full-width>
                            <div v-for="(item, index) in businesses" :key="index">
                                <v-list-item v-if="index!=0">
                                    <v-list-item-content>
                                      <v-list-item-title>{{item.BusinessName}}</v-list-item-title>
                                      <v-list-item-subtitle>Created On: {{item.CreatedOn}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-btn color="primary" outlined small @click="deactivate(item, index)">Delete</v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-divider v-if="businesses.length-1 != index"></v-divider>
                            </div>
                        </v-list>
                    </v-card-text>
                </div>

            </v-card>

        </v-dialog>
    </div>
</template>

<script>
    export default{
        props:['businesses', 'deactivate'],
        data(){
            return{
                dialog_deactivate_business:false
            }
        },
        methods:{
            openDialogWeb: function () {
                this.dialog_deactivate_business = true;
            },
            closeDialogWeb: function () {
                this.dialog_deactivate_business = false;
            },
        }
    }
</script>